import { getRoute } from 'helpers/route.helper/route.helper'
import { useState } from 'react'
import { useSystemFeatureFlagIsActive } from 'utils/systemUtils'

export const COLLAPSIBLE_LEGENDS_SYSTEM_FEATURE_FLAG = 'collapsible_legends'

const OPEN = 'open'
const CLOSED = 'closed'

function getStorageKey(persistKey: string): string {
  return `chartLegend_${getRoute()}_${persistKey}`
}

function readIsOpen(persistKey: string | undefined): boolean {
  if (!persistKey) {
    return true
  }

  try {
    return localStorage.getItem(getStorageKey(persistKey)) !== CLOSED
  } catch {
    return true
  }
}

function writeIsOpen(persistKey: string | undefined, isOpen: boolean): void {
  if (!persistKey) {
    return
  }

  try {
    localStorage.setItem(getStorageKey(persistKey), isOpen ? OPEN : CLOSED)
  } catch {
    return
  }
}

export function useCollapseLegends(persistKey: string | undefined): {
  canCollapse: boolean
  isOpen: boolean
  toggleOpen: () => void
} {
  const canCollapse = useSystemFeatureFlagIsActive(COLLAPSIBLE_LEGENDS_SYSTEM_FEATURE_FLAG)
  const [state, setState] = useState(() => ({ persistKey, isOpen: readIsOpen(persistKey) }))

  if (state.persistKey !== persistKey) {
    setState({ persistKey, isOpen: readIsOpen(persistKey) })
  }

  function toggleOpen(): void {
    const isOpen = !state.isOpen
    setState({ persistKey, isOpen })
    writeIsOpen(persistKey, isOpen)
  }

  return { canCollapse, isOpen: !canCollapse || state.isOpen, toggleOpen }
}
